import styled from "styled-components";

export const Container = styled.footer`
  background-color: ${({ theme }) => theme.THEME.background};
  text-align: center;
  z-index: 5;
  width: 100%;
  height: ${({ theme }) => theme.CONSTANTS.XH * 6.5}px;

  @media (min-width: 1025px) {
    height: ${({ theme }) => theme.CONSTANTS.XH * 10}px;
  }
`;

export const GradientLine = styled.div`
  width: 100%;
  height: 1.5px;
  background: ${({ theme }) => theme.THEME.base};
  background-size: 300% 100%;
  animation: moveGradient 3s linear infinite;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 2}px;

  @keyframes moveGradient {
    0% {
      background-position: 0% 50%;
    }
    100% {
      background-position: 100% 50%;
    }
  }
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  font-weight: 400;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
    margin-top: ${({ theme }) => theme.CONSTANTS.XH * 3.5}px;
  }
`;
